import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {NbDialogRef} from '@nebular/theme';
import {BaseComponent} from 'compob2b-libs';

@Component({
  selector: 'app-dam-preview-video',
  templateUrl: './dam-preview-video.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DamPreviewVideoComponent extends BaseComponent {
  @Input() uid: string;
  @Input() version: number;
  @Input() type: string;

  constructor(protected ref: NbDialogRef<DamPreviewVideoComponent>) {
    super();
  }

  dismiss(confirmed: boolean) {
    this.ref.close(confirmed);
  }

}
